const defaultState = {
    errorCodes:[],
    otpInfo:{}

  };
  
  const globalReducer = (state = defaultState, action) => {
      
    switch (action.type) {
      case "UPDATE_GLOBAL_STATE":
        return {
          ...state,
          ...action.payload,
        };
      default:
        return { ...state };
    }
  };
  
  export default globalReducer;